//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    name: 'JobPostCardSkeleton',

    computed: {
        height() {
            if (this.$breakpoint.xsOnly) {
                return 'unset'
            }

            return 410;
        }
    }
}
